import { BrowserRouter, Navigate, Route, Routes } from 'react-router';
import { ToastProvider } from '@podus/ui';
import { AuthProvider } from '@/context/AuthContext';
import ProtectedRoute from '@/components/ProtectedRoute';
import DashboardLayout, { AMBASSADOR_NAV, ADMIN_NAV } from '@/components/dashboard/DashboardLayout';

import Home from '@/pages/Home';
import Login from '@/pages/Auth/Login';
import AcceptInvite from '@/pages/Auth/AcceptInvite';
import ForgotPassword from '@/pages/Auth/ForgotPassword';
import ResetPassword from '@/pages/Auth/ResetPassword';
import AdminSignIn from '@/pages/Auth/AdminSignIn';
import AdminCallback from '@/pages/Auth/AdminCallback';

import AmbassadorOverview from '@/pages/Ambassador/Overview';
import AmbassadorReferrals from '@/pages/Ambassador/Referrals';
import AmbassadorSettings from '@/pages/Ambassador/Settings';

import AdminOverview from '@/pages/Admin/Overview';
import AdminAmbassadors from '@/pages/Admin/Ambassadors';
import AdminAmbassadorDetail from '@/pages/Admin/AmbassadorDetail';
import AdminDailyBreakdown from '@/pages/Admin/DailyBreakdown';
import AdminReferralReview from '@/pages/Admin/ReferralReview';
import AdminAuditLog from '@/pages/Admin/AuditLog';

import NotFound from '@/pages/NotFound';

export default function App() {
    return (
        <ToastProvider>
            <AuthProvider>
                <BrowserRouter>
                    <Routes>
                        {/* ── Public ── */}
                        <Route index element={<Home />} />
                        <Route path="sign-in" element={<Login />} />
                        <Route path="accept-invite" element={<AcceptInvite />} />
                        <Route path="forgot-password" element={<ForgotPassword />} />
                        <Route path="reset-password" element={<ResetPassword />} />

                        {/* Admin auth handoff to and from auth.podus.org */}
                        <Route path="admin/sign-in" element={<AdminSignIn />} />
                        <Route path="admin/callback" element={<AdminCallback />} />

                        {/* ── Ambassador dashboard ── */}
                        <Route element={<ProtectedRoute role="ambassador" />}>
                            <Route
                                path="dashboard"
                                element={<DashboardLayout navItems={AMBASSADOR_NAV} title="Ambassador dashboard" />}
                            >
                                <Route index element={<AmbassadorOverview />} />
                                <Route path="referrals" element={<AmbassadorReferrals />} />
                                <Route path="settings" element={<AmbassadorSettings />} />
                            </Route>
                        </Route>

                        {/* ── Admin dashboard ── */}
                        <Route element={<ProtectedRoute role="admin" />}>
                            <Route
                                path="admin"
                                element={<DashboardLayout navItems={ADMIN_NAV} title="Ambassador programme" />}
                            >
                                <Route index element={<AdminOverview />} />
                                <Route path="ambassadors" element={<AdminAmbassadors />} />
                                <Route path="ambassadors/:id" element={<AdminAmbassadorDetail />} />
                                {/* Invitations merged into the ambassador roster — kept as a
                                    redirect so existing bookmarks don't 404. */}
                                <Route
                                    path="invitations"
                                    element={<Navigate to="/admin/ambassadors?status=INVITED" replace />}
                                />
                                <Route path="daily" element={<AdminDailyBreakdown />} />
                                <Route path="referrals" element={<AdminReferralReview />} />
                                <Route path="audit" element={<AdminAuditLog />} />
                            </Route>
                        </Route>

                        <Route path="*" element={<NotFound />} />
                    </Routes>
                </BrowserRouter>
            </AuthProvider>
        </ToastProvider>
    );
}
